import React, { useEffect, useState } from 'react';
import { FileText, Download, Eye, Upload, X } from 'lucide-react';
import FileUpload from './FileUpload';
import * as utils from '../lib/utils.js'

const ShipmentDocuments = ({ documents,shipment, forwarder }) => {
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [showUploadPopup, setShowUploadPopup] = useState(false);
  const [documentsList, setDocumentsList] = useState(documents);

  const handleUploadClick = () => {
    console.log("Upload button clicked");
    setShowUploadPopup(true);
  };
  if (!documentsList) {
    return (
      <div className="p-6">
        <div className="animate-pulse flex space-x-4">
          <div className="flex-1 space-y-6 py-1">
            <div className="h-4 bg-gray-200 rounded w-3/4"></div>
            <div className="space-y-3">
              <div className="grid grid-cols-3 gap-4">
                <div className="h-4 bg-gray-200 rounded col-span-2"></div>
                <div className="h-4 bg-gray-200 rounded col-span-1"></div>
              </div>
              <div className="h-4 bg-gray-200 rounded"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow">
      <div key={shipment} className="border-b last:border-b-0">
        <div className="p-4 bg-gray-50 flex justify-between items-center">
          <h3 className="text-sm font-medium text-gray-900">
            Shipment: {shipment}
          </h3>
          <button
            onClick={handleUploadClick}
            className="px-3 py-1.5 text-sm font-medium text-white bg-accent-600 hover:bg-accent-700 rounded-md flex items-center"
          >
            <Upload size={16} className="mr-2" />
            Add Documents
          </button>
        </div>
        <div className="divide-y">
          {documentsList.map((doc) => (
            <div
              key={doc.id}
              className="p-4 hover:bg-gray-50 flex items-center justify-between"
            >
              <div className="flex items-center space-x-4">
                <div className="flex-shrink-0">
                  <span className="inline-flex items-center justify-center h-8 w-8 rounded-lg bg-accent-50 text-accent-700 text-xs font-medium">
                    {doc.fields?.DocumentType && utils.getDocumentTypeIcon(doc.fields.DocumentType)}
                  </span>
                </div>
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-medium text-gray-900 truncate">
                    {doc.fields?.FileLeafRef}
                  </p>
                  <div className="flex items-center space-x-3 text-xs text-gray-500">
                    {doc.fields?.DocumentType && (
                      <>
                        <span>{doc.fields.DocumentType}</span>
                        <span>•</span>
                      </>
                    )}
                    {doc.fields?.FileSizeDisplay && (
                      <>
                        <span>{utils.formatFileSize(doc.fields.FileSizeDisplay)}</span>
                        <span>•</span>
                      </>
                    )}
                    {doc.fields?.Modified && (
                      <span>
                        {new Date(doc.fields.Modified).toLocaleDateString()}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                {doc.webUrl && (
                  <button
                    onClick={() => window.open(doc.webUrl, '__blank')}
                    className="p-1 text-gray-400 hover:text-gray-500"
                    title="View"
                  >
                    <Eye size={16} />
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      { documentsList.length == 0 && (
       <div className="bg-gray-50 border border-gray-200 rounded-md p-8 text-center">
                    <FileText size={48} className="mx-auto text-gray-400 mb-4" />
                    <p className="text-gray-500">No documents available</p>
                    <button
                      onClick={() => setShowUploadPopup(true)}
                      className="mt-4 px-4 py-2 text-sm font-medium text-white bg-accent-600 hover:bg-accent-700 rounded-md inline-flex items-center"
                    >
                      <Upload size={16} className="mr-2" />
                      Add Documents
                    </button>
                  </div>
      )}
      {showUploadPopup && (
        <FileUpload
          onClose={() => setShowUploadPopup(false)}
          shipment={shipment}
          forwarder={forwarder}
          setDocumentsList={setDocumentsList}
        />
      )}
    </div>
  );
};

export default ShipmentDocuments; 

